import { addLastPrefixEN } from '../transforms/addLastPrefix';
import { formatOrdinalEN } from '../transforms/formatOrdinal';
import { removeDots } from '../transforms/removeDots';
import { uppercase } from '../transforms/uppercase';
import { overrideBaseLocale } from './base-config';
export var enCA = overrideBaseLocale('en-CA', {
    dayOfMonthOrdinal: {
        options: {
            day: 'numeric',
        },
        transforms: [formatOrdinalEN],
    },
    dayOfWeekShort: {
        options: {
            weekday: 'short',
        },
        transforms: [removeDots],
    },
    dayOfWeekShortUppercase: {
        options: {
            weekday: 'short',
        },
        transforms: [removeDots, uppercase],
    },
    dayOfWeekShortPropercase: {
        options: {
            weekday: 'short',
        },
        transforms: [removeDots],
    },
    lastDayOfWeekLong: {
        options: {
            weekday: 'long',
        },
        transforms: [addLastPrefixEN],
    },
    monthShort: {
        options: {
            month: 'short',
        },
        transforms: [removeDots],
    },
    monthShortUppercase: {
        options: {
            month: 'short',
        },
        transforms: [removeDots, uppercase],
    },
    monthShortPropercase: {
        options: {
            month: 'short',
        },
        transforms: [removeDots],
    },
});
//# sourceMappingURL=en-CA.js.map